import React from 'react';
import { RestaurantProvider } from 'providers';
import HomePage from './Page';

export { default as Site } from './site';
export { default as RestaurantDetails } from './restaurants/[id]';
export { default as Cart } from './cart';
export { default as Login } from './login';
export { default as Register } from './register';
export { default as ResetPassword } from './reset-password';
export { default as UpdatePassword } from './reset-password/[token]';
export { default as UserRequests } from './user-requests';
export { default as UserRequestDetails } from './user-requests/[id]';
export { default as NotFound } from './not-found';
export { default as Tables } from './garcom/tables';
export { default as Dashboard } from './app';
export { default as Admin } from './admin';
export { default as AdminCategories } from './admin/categories';
export { default as AppCategories } from './app/categories';
export { default as AppProducts } from './app/products';
export { default as AppRequests } from './app/requests';
export { default as AppCategoryProductOptions } from './app/category-product-options';
export { default as AppTables } from './app/tables';
export { default as AppSettings } from './app/settings';
export { default as AppUsers } from './app/users';

export function Home() {
  return (
    <RestaurantProvider>
      <HomePage />
    </RestaurantProvider>
  );
}
